import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const LineChart = ({ title = '', data = [], datasets = [], getLabel }) => {
  const labels = data.map(item =>
    getLabel ? getLabel(item) : (item.date || item.createdAt || 'Unknown')
  );

  const chartData = {
    labels,
    datasets: datasets.map(ds => ({
      label: ds.label,
      data: data.map(d => d[ds.key]),
      borderColor: ds.color || 'rgb(0, 0, 0)',
      backgroundColor: ds.bgColor || 'rgba(0, 0, 0, 0.3)',
      tension: 0.3,
      pointRadius: 3,
      pointHoverRadius: 6
    }))
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom',
        align: 'center',
        labels: {
          usePointStyle: true,
          boxWidth: 12,
          padding: 12,
          font: {
            size: 13
          }
        }
      },
      title: {
        display: !!title,
        text: title,
        font: {
          size: 18
        }
      }
    },
    layout: {
      padding: {
        top: 10,
        bottom: 20
      }
    }
  };

  return <Line options={options} data={chartData} />;
};

export default LineChart;